import ODSPriorityGroupLayout from '../../components/SharedLayouts/ODSPriorityGroupLayout/ODSPriorityGroupLayout';
import ods_logo from '../../assets/img/ods.png';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { useEffect } from 'react';
import { getODS } from '../../redux/slices/odsPriorityGroups/odsPriorityGroupsThunk';

const Index = () => {
    const dispatch = useAppDispatch();

    const { ods } = useAppSelector((state) => state.ods_priorityGroups);

    useEffect(() => {
        if (!ods) {
            dispatch(getODS());
        };
    }, [ods, dispatch]);

    return (
        <>
            <ODSPriorityGroupLayout
                titleHero='ODS'
                descriptionHero='Esta sección te da acceso a los indicadores del Monitor vinculados con los compromisos asumidos por la Ciudad de Buenos Aires en el marco de los Objetivos de Desarrollo Sostenible, propuestos por la Agenda 2030 de Naciones Unidas. Al navegarla, vas a poder seguir los avances y retrocesos de cada ODS, representado con su iconografía oficial.'
                imgHero={ods_logo}
                data={ods ?? []}
            />
        </>
    )
}

export default Index